module.exports = __webpack_public_path__ + "media/icons/chat-bubble-084a5fe6.svg";